import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkTableModule } from '@angular/cdk/table';

import { SupplierFilesRoutingModule } from './supplier-files-routing.module';
import { SupplierFilesComponent } from './supplier-files.component';
import { SupplierFilesTableComponent } from './supplier-files-table/supplier-files-table.component';
import { SupplierFilePreviewModalComponent } from './supplier-file-preview-modal/supplier-file-preview-modal.component';
import { SupplierFilesPeriodModalComponent } from './supplier-files-period-modal/supplier-files-period-modal.component';

import { SharedModule } from 'src/app/shared/shared.module';
import { CardModule } from 'src/app/ui/card/card.module';
import { CheckboxModule } from 'src/app/ui/checkbox/checkbox.module';
import { EmptyPatternModule } from 'src/app/ui/empty-pattern/empty-pattern.module';
import { IconModule } from 'src/app/ui/icon/icon.module';
import { InputModule } from 'src/app/ui/input/input.module';
import { ModalModule } from 'src/app/ui/modal/modal.module';
import { PageTitleModule } from 'src/app/ui/page-title/page-title.module';
import { PaginatorModule } from 'src/app/ui/paginator/paginator.module';
import { SelectModule } from 'src/app/ui/select/select.module';
import { TabModule } from 'src/app/ui/tab/tab.module';

// ToastModule nao entra aqui: o ToastService vem do CoreModule, e uma segunda
// instancia escreveria em uma lista que o <c-toast> do shell nao le.
@NgModule({
  declarations: [
    SupplierFilesComponent,
    SupplierFilesTableComponent,
    SupplierFilePreviewModalComponent,
    SupplierFilesPeriodModalComponent
  ],
  imports: [
    CommonModule,
    SupplierFilesRoutingModule,
    SharedModule,
    CdkTableModule,
    CardModule,
    CheckboxModule,
    EmptyPatternModule,
    IconModule,
    InputModule,
    ModalModule,
    PageTitleModule,
    PaginatorModule,
    SelectModule,
    TabModule
  ]
})
export class SupplierFilesModule { }
